import React, { useState }  from "react";
import {Card}               from "react-bootstrap";
import { Button }           from "react-bootstrap";

import '../App.css';

//--------------------------------------------------------
//  Component definition'
//
//--------------------------------------------------------
export default function MyCardV2(props) 
{
  const text = props.text;
  let component;
  let maxHeight = 600;
 
  let backgroundColor = "#B09070";  

  const [pic, setPic] = useState(
    {
      small_size: true,
      width:      '100%'
    } );
    
  if (props.backgroundColor)
  {
    backgroundColor = props.backgroundColor;
  }
  
  //---------------------------------------------
  //  W3 need a callback to the caller of the card
  //---------------------------------------------
  function myClick(e)
  {
  console.log('myCard.click')
  e.stopPropagation();
  props.detail(e)
  }  
  
  //-------------------------------------------------
  //  prepare what to render
  //-------------------------------------------------
    component =
    <Card style={{ color:'white', boxShadow: '5px 5px 5px black', fontSize: '2vh', width: '30vw', 
                   backgroundColor: backgroundColor, textAlign: "justify", padding:8, margin: 30, height: "maxHeight" }} onContextMenu={(e) => e.preventDefault()}>
        <Card.Header style={{color:'black', fontSize: '3vh', fontWeight:'bold' }}>{props.title}</Card.Header>
        <Card.Img src={props.img} variant="top" alt="Card" width={pic.width}  onClick={(e) => myClick(e)}onMouseDown={(e) => e.stopPropagation()}/>
        <Card.Body >
          <Card.Text >{text}  </Card.Text>
          </Card.Body>
        <Card.Footer className='card-footer'>
         <Button style={{backgroundColor: "#808080", borderColor: "#606060"}} variant="info" size="sm" onClick={(e) => myClick(e)} onMouseDown={(e) => e.stopPropagation()}> See more...</Button>
        </Card.Footer>
    </Card>
     
    return component
}